// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1aBFS","info":"Note_info__1qNV_","note":"Note_note__3kiKa","actions":"Note_actions__2Oac5"};